import { useEffect } from 'react';
import MastheadNav from './MastheadNav';
import HeroSection from './HeroSection';
import WhatItDoes from './WhatItDoes';
import TheVision from './TheVision';
import WaitlistBlock from './WaitlistBlock';
import LandingFooter from './LandingFooter';

export default function LandingBeta() {
  // Scope the light-mode parchment canvas to this page only.
  // Restored on unmount so other routes keep their dark canvas.
  useEffect(() => {
    const prevBg = document.body.style.backgroundColor;
    const prevColor = document.body.style.color;
    document.body.style.backgroundColor = '#F0E3BF';
    document.body.style.color = '#2B2414';
    return () => {
      document.body.style.backgroundColor = prevBg;
      document.body.style.color = prevColor;
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#F0E3BF] text-[#2B2414]">
      <MastheadNav />
      <main>
        <HeroSection />
        <WhatItDoes />
        <TheVision />
        <WaitlistBlock />
      </main>
      <LandingFooter />
    </div>
  );
}
